// @ts-ignore
export const environment = {
	connectApiHost: 'https://staging-connect-api.pleiads.fr/api/v1',
	defaultRedirectApplicationUrl: 'https://core.kampn.com',
	preventRedirect: false,
	aws: {
		s3Bucket: 'https://kafoutche-public-images.s3.eu-west-3.amazonaws.com/',
		cloudfrontHost: 'https://d1tsymw5mfecuq.cloudfront.net/',
		bucketDirectory: 'assets/platform'
	}
};
